import React from "react";
import Slider from "react-slick";
const defaultImage = require('../../../../media/sancoIcon_trans.png');

export class SpeciesScoresColVert extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      boatScores: [],
      logs: [],
      classLogs: [],
      boatClass: this.props.boatClass,
      speciesId: this.props.speciesId,
      speciesName: this.props.speciesName,
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs, speciesId: newProps.speciesId, speciesName: newProps.speciesName, boatClass: newProps.boatClass});
    this.classFilter(newProps.logs);
      
  }
    
  classFilter(logs) {
      var classLogs = [];
      logs.forEach((boat) => {
          if(boat.boatClass === this.state.boatClass) {
              classLogs.push({
                  id: boat.id,
                  boatClass: boat.boatClass,
                  boatName: boat.boatName,
                  boatThm: boat.boatThm,
                  boatCaughtFish:boat.boatCaughtFish,
                  lastFishTime: boat.lastFishTime,
                  total: boat.total
              });
          }
      })
    this.getSpeciesPoints(this.state.speciesId, classLogs)
  }
    
  getLastFishTime(times){
      var timesArray = [];
      times.forEach((time) => {
          if(time.speciesTimes){
              time.speciesTimes.forEach((t) => {
                  var secs = new Date(t).getTime() / 1000;
                  timesArray.push(secs);
              })
          }
      })
      timesArray.sort((a, b) => b - a);
      
      return timesArray;
  }

  getSpeciesPoints(speciesId, classLogs) {
    var boatTotals = [];
    classLogs.forEach((boatLog) => {
      var totalPoints = 0;
      var speciesCount = 0;
      var lastF = [];
      boatLog.boatCaughtFish.forEach((log) => {
        if(speciesId === log.speciesId && log.lbs > 0) {
          totalPoints = totalPoints + parseFloat(log.lbs);
        }
        if(speciesId === log.speciesId) {
          speciesCount++
          lastF.push(new Date(log.catchDate).getTime())
        }
      });
      var points = parseFloat(totalPoints.toFixed(2));
      if(points > 0){
        var d = new Date(boatLog.lastFishTime);
        boatTotals.push({
          id: boatLog.boatId,
          boatName: boatLog.boatName,
          boatThm: boatLog.boatThm,
          total: points,
          lastFishTime: boatLog.lastFishTime,
          lastSpeceiesFishTime: this.getLastFishTime(lastF),
          lastTime: parseInt(Math.round(d.getTime() / 1000))
        })
      }
    })
    this.scoreSortFilter(boatTotals);
  }

  scoreSortFilter(boatTotals) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    if(boatTotals && boatTotals.length >= 1) {
      boatTotals.sortOn("total", "lastSpeceiesFishTime");
      boatTotals.reverse();
    }
  
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
      var boatScoresArray = boatTotals.filter(filterByTotal);
      var rank = 1;
      var bScores = [];
      boatScoresArray.forEach((boat) => {
        bScores.push({
          rank: rank++,
          boat: boat
        })
      })
      if(bScores.length > 0) {
          this.setState({
            boatScores: bScores,
          })
      } else {
          this.setState({
            boatScores: [],
          })
      }
  }
  render() {
    if(this.state.boatScores.length === 1){
      var numSlides = 1;
    } if(this.state.boatScores.length === 2){
      var numSlides = 1;
    } if(this.state.boatScores.length === 3){
      var numSlides = 2;
    } if(this.state.boatScores.length === 4){
      var numSlides = 3;
    }else {
      var numSlides = 4;
    }
    const settings = {
			customPaging: function(i) {
        return (
          <a>
            {i + 1}
          </a>
        );
      },
      dots: true,
			dotsClass: "slick-dots slick-thumb",
      arrows: false,
      infinite: false,
      slidesToShow: numSlides,
      slidesToScroll: numSlides,
      swipeToSlide: true,
			vertical: true,
    };
    return (
        <div className="smv-scoreContainer">
        <div className="score_box_title">{ this.state.speciesName }</div>
          { this.state.boatScores.length > 0 ? <Slider {...settings}>
          { this.state.boatScores.map((boat, index) => (
            <div className="smv-boatBox" key={boat.boat.id}>
                <div id='boat-total' className="smv-logCellPhone">
									<div  className="smv-cellDetailsBox">
                    <div className="smv-rankBox1">
											# {boat.rank} {boat.boat.boatName}
										</div>
										{boat.boat.teamName != boat.boat.boatName ? <div id='rank' className="smv-rankBox2">Team: {boat.boat.teamName}</div>: null}
									</div>
									<div id='boat-total' className="smv-boat-total-box">
										{boat.boat.total} pts
									</div>
								</div>
            </div>
          ))}
        </Slider> : <div className="smv-speciesName">No { this.state.speciesName } weighed yet.</div> 
        }
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/qbc/comps/SpeciesScoresColVert.js